import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const COLORS = ['#ffb547', '#ef4565', '#22d3ee', '#a3e635', '#c084fc', '#f5f7fb'];

interface Piece { id: number; x: number; rot: number; delay: number; color: string; size: number }

export function Confetti({ active, count = 64 }: { active: boolean; count?: number }) {
  const [pieces, setPieces] = useState<Piece[]>([]);

  useEffect(() => {
    if (!active) return;
    const arr: Piece[] = Array.from({ length: count }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      rot: Math.random() * 720 - 360,
      delay: Math.random() * 0.4,
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      size: 6 + Math.random() * 8,
    }));
    setPieces(arr);
    const t = setTimeout(() => setPieces([]), 4500);
    return () => clearTimeout(t);
  }, [active, count]);

  if (pieces.length === 0) return null;
  return (
    <div className="pointer-events-none fixed inset-0 z-40 overflow-hidden">
      {pieces.map(p => (
        <motion.span
          key={p.id}
          initial={{ y: -40, x: `${p.x}vw`, rotate: 0, opacity: 1 }}
          animate={{ y: '110vh', rotate: p.rot, opacity: [1, 1, 0.8, 0] }}
          transition={{ duration: 2.6 + Math.random() * 1.2, delay: p.delay, ease: 'easeIn' }}
          style={{
            position: 'absolute',
            top: 0,
            display: 'inline-block',
            width: p.size,
            height: p.size * 0.6,
            background: p.color,
            borderRadius: 2,
          }}
        />
      ))}
    </div>
  );
}
